import { render, staticRenderFns } from "./PlainHtmlModule.vue?vue&type=template&id=5235de6f&"
import script from "./PlainHtmlModule.ts?vue&type=script&lang=ts&"
export * from "./PlainHtmlModule.ts?vue&type=script&lang=ts&"
import style0 from "./PlainHtmlModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports